import subscribeToAssetUpdateWithConfig from './Subscribers/subscribeToAssetUpdateWithConfig';
import createAssetUpdateWithConfigStream from './Streams/createAssetUpdateWithConfigStream';

const connectPlaybackApiSubscriptions = middleware => {
    const {
        config,
        asset,
    } = middleware.state.stores;

    return [
        subscribeToAssetUpdateWithConfig(
            createAssetUpdateWithConfigStream(asset.update$, config.update$),
            middleware.apiServices.playback.request$
        ),
    ];
};

export default connectPlaybackApiSubscriptions;
